// extracted by mini-css-extract-plugin
module.exports = {"container":"Create_container__3L1Vc","title":"Create_title__2OkQX","desc":"Create_desc__2h8ly"};